import styled from 'styled-components';
import {
  DialogTitle as MUIDialogTitle,
  Dialog as MUIDialog,
  DialogContent as MUIDialogContent,
  Divider,
  Popover,
  Box,
  Typography,
  Tooltip,
  TextField,
} from '@mui/material';

import withStyles from '@mui/styles/withStyles';

import { colors } from 'spw-theme';
import { Column, Row, SPWDeleteButton } from 'spw-shared/globalComponents';
import { SPWMainButton } from 'spw-shared/globalComponents/buttons';
import Img from 'react-cool-img';
import { ActionsDialogContainer } from 'spw-components/dialogs/styles';

export const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const ButtonGroup = styled(FlexBox)`
  margin-right: 16px;
`;

export const StateButtonGroup = styled(FlexBox)`
  & > div:last-child button,
  & > button:last-child {
    margin-right: 24px;
  }
`;

export const SnappingButtonGroup = styled(FlexBox)`
  & > div:last-child button,
  & > button:last-child {
    margin-right: 0;
  }
`;

export const SnappingButton = styled(FlexBox)`
  && {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    justify-content: center;
    border: 1px solid;
    box-sizing: border-box;
    cursor: pointer;
  }

  &:hover {
    background-color: ${colors.backgroundGrey};
  }
`;

export const ObjectSnapPopoverContent = styled(Column)`
  && {
    width: 332px;
    padding: 16px;
  }
`;

export const ObjectSnapTitle = styled(FlexBox)`
  && {
    padding-bottom: 8px;
  }

  div {
    margin-left: 8px;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const CustomPopOver = styled(Popover)`
  max-height: 300px;
`;

export const Container = styled.div`
  && {
    width: 1000px;
    height: 600px;
    background: ${colors.backgroundGrey};

    border: 2px solid ${colors.containerBorder};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    .MuiButton-label {
      text-transform: none;
    }
  }

  &.hidden {
    display: none;
  }
`;

export const BlankContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(100vh - 206px);
  position: relative;
  bottom: 0px;
  user-select: none;
`;

export const UploadLegend = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  margin-top: 0;
  display: flex;
  flex-direction: column;

  ul {
    list-style-position: outside;
    padding-left: 15px;

    li {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: ${colors.fontColor};
    }
  }

  h4 {
    margin-top: 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    margin-left: -15px;
  }

  button.MuiButton-text {
    margin-top: 16px;
    margin-right: 0;
  }
`;

export const Upload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background-color: ${colors.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  max-width: 330px;
  z-index: 103;
`;

export const FloorInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 1000px;
  justify-content: start;
  align-items: flex-end;
  padding-bottom: ${({ $paddingBottom }: { $paddingBottom: number }) =>
    $paddingBottom}px;
  flex: 1;
  height: 28.5px;
`;

export const FloorNumber = styled(Typography)`
  && {
    font-weight: 500;
    font-size: 24px;
    height: 27px;
    margin-right: 10px;
    color: ${colors.black};
    max-height: 32px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: right;
  flex: 1;
`;

export const UploadButton = styled(SPWMainButton)`
  && {
    padding: 0 16px;
    align-self: center;
    border-radius: 3px;
    margin-right: 16px;

    span.MuiButton-label {
      text-transform: uppercase;
    }

    span {
      font-size: 14px;
      display: flex;
      align-items: center;

      .MuiCircularProgress-root {
        width: 20px !important;
        height: 20px !important;
        margin-right: 8px;
      }
    }
  }
`;

export const UploadGuideContainer = styled.div`
  background-color: ${colors.statusIndicatorsBackground};
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 16px;
  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    a {
      font-weight: 700;
      color: ${colors.mainBlue};
    }
  }
`;

export const FullWidthUploadButton = styled(UploadButton)`
  width: 100%;
`;

export const UploadContainerTitle = styled(Typography)`
  && {
    margin-top: 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: ${colors.black};
    margin-bottom: 8px;
  }
`;

export const UploadContainerSubtitle = styled(Typography)`
  && {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: ${colors.black};
  }
`;

export const UploadContainerList = styled.ul`
  margin: 8px 0;
`;

export const MapContainer = styled.div`
  && {
    width: 1000px;
    height: 600px;
    border-radius: 4px;
    border: 1px solid ${colors.mainGray};
    z-index: 1;

    .leaflet-bottom {
      display: none;
    }
  }
`;

export const ControlContainer = styled.div`
  && {
    width: 100%;
    max-width: 1000px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-item: center;
    margin: 16px 0; // needs to match Prompt Container
    justify-content: flex-start;
    height: 45px; // needs to match Prompt Container
  }
`;

export const ControlLegend = styled(Typography)`
  && {
    margin-top: 1px;
    color: ${colors.fontColor};
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    margin-right: 8px;
  }
`;

export const FloorplanButton = styled.button`
  cursor: pointer;
  margin-right: 8px;
  position: relative;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #707070;
  box-sizing: border-box;

  &.default-cursor {
    cursor: default;
  }

  &.inactive {
    opacity: 1;
  }

  &.disabled {
    opacity: 0.75;
    cursor: initial;
    pointer-events: none;
  }

  &.individual-active {
    border: 0px solid ${colors.white};
    background-color: ${(props) => `${props.color}`};
  }

  &.individual-intermediate {
    background-color: ${colors.white};
    border: ${(props) => ` 3px solid ${props.color}`};
  }

  &.meeting-active {
    border: 0px solid ${colors.white};
    background-color: ${(props) => `${props.color}`};
  }

  &.amenity-active {
    border: 0px solid ${colors.white};
    background-color: ${(props) => `${props.color}`};
  }

  &.support-active {
    border: 0px solid ${colors.white};
    background-color: ${(props) => `${props.color}`};
  }

  &.other-active {
    border: 0px solid ${colors.white};
    background-color: ${(props) => `${props.color}`};
  }

  &.dark-active {
    background-color: ${colors.mainGray};
  }
`;

export const FloorplanIcon = styled.img`
  width: 20px;
  height: 20px;
  pointer-events: none;

  &.other {
    width: 28px;
    height: 28px;
  }

  &.meeting {
    width: 20px;
    height: 20px;
  }

  &.calibration {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  &.calibrate,
  &.add-usf {
    width: 24px;
    height: 24px;
  }
`;

export const CustomDivider = styled(Divider)`
  && {
    background-color: #e0e0e0;
    margin-right: 8px;
  }

  &.large-right-margin {
    margin-right: 24px;
  }
`;

export const StatusButton = styled.div`
  && {
    position: absolute;
    width: 15px;
    height: 15px;
    right: 2px;
    top: 20px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;

export const Green = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 3px;
  background: #02c39a;
`;

export const Gray = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 3px;
  background: #c4c4c4;
`;

export const ButtonTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#fff',
    color: colors.mainGray,
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.11)',
    fontSize: 14,
    fontWeight: 500,
    padding: '9px 14px',
    borderRadius: '3px',
  },
}))(Tooltip);

export const ButtonWithSubimageWrapper = styled.div`
  position: relative;
`;

export const SubImage = styled(Img)`
  position: absolute;
  z-index: 1;
`;

export const FloorContainer = styled.div`
  width: 100%;

  div.leaflet-marker-icon.icon.small-icon.leaflet-zoom-animated {
    margin-left: 0px !important;
    margin-top: 2px !important;
  }

  svg.leaflet-zoom-animated g path.snapping-layer.leaflet-interactive {
    cursor: unset !important;
  }

  // the following are css rules for the shape vertices

  #floorplan-map.cropping-mode {
    background-color: ${colors.mainGrayAt60};

    div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable:not(.icon) {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      border: none !important;
      border-radius: 0 !important;
      background-color: transparent !important;
      &:nth-child(odd) {
        width: 14px !important;
        height: 40px !important;
        background-image: url('/images/crop-handle-vertical.svg') !important;
        top: -13px;
        left: 1px;
        &:hover {
          cursor: ew-resize !important;
        }
      }
      &:nth-child(even) {
        width: 40px !important;
        height: 14px !important;
        background-image: url('/images/crop-handle-horizontal.svg') !important;
        left: -13px;
        &:hover {
          cursor: ns-resize !important;
        }
      }
    }
  }

  #floorplan-map.preview-mode {
    .cursor-marker {
      opacity: 0 !important;
      border: none !important;
    }

    div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable,
    div.leaflet-marker-icon.marker-icon.leaflet-interactive {
      border-color: ${colors.hotPink} !important;
      background-color: ${colors.white} !important;
    }
  }

  &.selection-mode {
    .cursor-marker {
      opacity: 0 !important;
      border: none !important;
    }

    div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable,
    div.leaflet-marker-icon.marker-icon.leaflet-interactive {
      border-color: ${colors.hotPink} !important;
      background-color: ${colors.white} !important;
    }
  }

  &.calibration-mode {
    div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable,
    div.leaflet-marker-icon.marker-icon.leaflet-interactive,
    div.leaflet-marker-icon.marker-icon.leaflet-interactive.cursor-marker.visible,
    .cursor-marker.visible {
      border-color: ${colors.hotPink} !important;
      background-color: transparent !important;
    }

    svg.leaflet-zoom-animated g path,
    .leaflet-interactive {
      cursor: crosshair !important;
    }
    svg.leaflet-zoom-animated g path.snapping-layer.leaflet-interactive {
      cursor: unset !important;
    }
  }

  &.usf-measurement-mode {
    svg.leaflet-zoom-animated g path,
    .leaflet-interactive:not(.scale-vertex) {
      cursor: unset !important;
    }
    svg.leaflet-zoom-animated g path.snapping-layer.leaflet-interactive {
      cursor: unset !important;
    }
    svg.leaflet-zoom-animated g path.leaflet-interactive.leaflet-pm-draggable {
      cursor: move !important;
    }
    div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable,
    div.leaflet-marker-icon.marker-icon.leaflet-interactive {
      border-color: ${colors.hotPink} !important;
      background-color: transparent !important;
    }

    div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable:not(.scale-vertex),
    div.leaflet-marker-icon.marker-icon.leaflet-interactive:not(.scale-vertex) {
      cursor: crosshair !important;
    }

    div.leaflet-marker-icon.marker-icon.leaflet-interactive.cursor-marker.visible,
    div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable.leaflet-drag-target,
    .cursor-marker.visible {
      border-color: ${colors.hotPink} !important;
    }

    #floorplan-map.delete-vertex-mode {
      div.leaflet-marker-icon.marker-icon.leaflet-interactive.leaflet-marker-draggable,
      div.leaflet-marker-icon.marker-icon.leaflet-interactive {
        border: 1.5px ${colors.red} solid !important;
        background-color: transparent !important;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer !important;

        &:before,
        &:after {
          content: '';
          height: 75%;
          width: 1px;
          background-color: ${colors.red};
          position: absolute;
          top: 50%;
          left: 50%;
        }

        &:before {
          transform: translateY(-50%) translateX(-50%) rotate(45deg);
        }

        &:after {
          transform: translateY(-50%) translateX(-50%) rotate(-45deg);
        }
      }
    }
  }
`;

export const FloorUSF = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  height: 14px;
  padding-left: 2%;
`;

export const MiniModalWrapper = styled.div`
  display: flex;
  padding: 8px 16px;
`;

export const LeftColumn = styled(Column)`
  font-family: 'Roboto';
  font-weight: 400;
  justify-content: center;
`;

export const MiniModalButtonsContainer = styled.div`
  margin-left: 16px;
  padding-top: 6px;
  padding-bottom: 6px;

  > button {
    height: 20px;
    width: 20px;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }
`;

export const MiniModalTitle = styled.div`
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  color: #000;
`;

export const MiniModalDescription = styled.div`
  display: flex;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: #4a4a4a;
`;

export const MiniModalDataDivider = styled.div`
  width: 12px;
  height: 16px;
`;

export const FullWidthRow = styled(Row)`
  width: 100%;
  justify-content: space-between;
`;

export const CalibratePromptText = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */

  display: flex;
  align-items: center;
`;

export const PromptContainer = styled.div`
  margin: 16px 0;
  height: 45px;
  max-width: 1000px; /* matches map container */
`;

export const FeetInput = styled(TextField)`
  && {
    width: 86px;
    height: 40px;
    margin: 0;
    margin-left: 16px;
    margin-right: 4px;

    .MuiInputBase-adornedEnd {
      padding-right: 8px;
    }

    .MuiOutlinedInput-root {
      height: 100%;
    }

    .MuiOutlinedInput-input {
      padding-right: 0px;
      padding-left: 6px;
    }

    .MuiOutlinedInput-notchedOutline {
      padding-right: 0;
    }

    input {
      text-align: right;
    }
  }
`;

export const MillimetersInput = styled(FeetInput)`
  && {
    width: 100px;
  }
`;

export const InchesInput = styled(FeetInput)`
  && {
    width: 72px;
    height: 40px;
    margin-right: 8px;

    .MuiOutlinedInput-notchedOutline {
      padding-right: 0;
    }

    input {
      text-align: right;
    }
  }
`;

export const ModalText = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 20px;
  color: ${colors.black};
`;

export const ButtonWrapper = styled.div`
  margin-right: 16px;

  &.margin-left {
    margin-left: 16px;
  }
`;

export const ModalTitle = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 32px;
  line-height: 28px;
`;

export const Dialog = styled(MUIDialog)`
  && {
    padding: 24px;
  }
`;

export const DialogContent = styled(MUIDialogContent)`
  && {
    padding: 24px;
  }
`;

export const DialogTitle = styled(MUIDialogTitle)`
  && {
    padding: 24px;
    padding-bottom: 0;
  }
`;

export const CalibrationRequiredWrapper = styled.div`
  margin-bottom: 48px;
  width: 345px;

  .title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    margin-left: 8px;
  }

  p {
    margin-top: 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const UploadFileError = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.red};
  font-size: 14px;
  line-height: 20px;

  img {
    margin-right: 8px;
  }

  margin-bottom: 16px;
`;

export const KeyboardShortcutsTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 4px;

  thead tr {
    background-color: ${colors.brightGray};

    th {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      padding-top: 8px;
      padding-bottom: 4px;
    }
  }

  tbody tr td {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding-top: 12px;
    padding-bottom: 11px;

    &:nth-child(2) {
      width: 58px;
    }

    &:nth-child(3) {
      width: 73px;
    }
  }

  tbody tr:not(:last-child) td {
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      border-bottom: 1px solid ${colors.veryLightGray};
    }
  }

  th,
  td {
    border: none;

    &:first-child,
    &:last-child {
      width: 14px;
    }
  }

  .icon-image {
    width: 20px;
    height: 20px;
    transform: translateY(3px);
  }
`;

export const StickyMouseTooltipContent = styled.div`
  background-color: ${colors.white};
  border: 1px solid ${colors.veryLightGray};
  font-size: 14px;
  line-height: 16px;
  color: ${colors.fontColor};
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
`;

export const ZOOM_IN_TEXT = `
  <div class="zoom-in-icon"
    style="
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    "
  />
`;

export const ZOOM_OUT_TEXT = `
<div class="zoom-out-icon"
  style="
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  "
/>
`;

export const ToolBarControlButton = styled.div`
  z-index: 500;
  width: 34px !important;
  height: 34px !important;
  border: 0 !important;
  padding: 6px !important;
  border-bottom: 1px solid ${colors.mainGray} !important;
  background-color: ${colors.backgroundGrey} !important;
  box-sizing: border-box;
  position: relative;

  &:first-child {
    border-top-left-radius: 3px !important;
    border-top-right-radius: 3px !important;
  }

  &:last-child {
    border-bottom: none !important;
    border-bottom-left-radius: 3px !important;
    border-bottom-right-radius: 3px !important;
  }

  &:hover,
  &.active {
    background-color: ${colors.grayMedium} !important;
  }

  &:focus-visible {
    outline: none;
  }

  &.disabled {
    background-color: ${colors.backgroundGrey} !important;
    cursor: default !important;

    .leaflet-pm-icon-rotate,
    .move-spaces-icon,
    .scale-spaces-icon {
      opacity: 0.4;
    }
  }
`;

export const DeleteCalibrationButton = styled(SPWDeleteButton)`
  && {
    width: 88px;
    margin-left: 16px;
  }
`;

export const ToolbarContainer = styled.div`
  width: 34px;
  border: 1px solid ${colors.mainGray};
  box-shadow: none;
  background-color: ${colors.mainGray};
`;

export const ToolbarHandle = styled.div`
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  img {
    width: 20px;
    height: 16px;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
`;

export const ExitConfirmationDialogContainer = styled(ActionsDialogContainer)`
  && {
    height: 200px;
  }

  && .description {
    font-size: 16px;
  }

  & button {
    font-size: 14px;
    line-height: 16px;
  }

  & button:first-child {
    width: 88px;
  }
`;
